export default __webpack_public_path__ + "locales/tr/DeleteDialog.json?hash=7e96fb850f9bd32c4ded01bd3f39eb03";